import PropTypes from 'prop-types';
import React, { Component } from 'react';
import BaseElement from '../BaseElement/BaseElement';
import assign from 'lodash/assign';
import clone from 'lodash/clone';
import shallowEqual from 'fbjs/lib/shallowEqual';
import { getResizeUrlByUserPreference } from 'MyAccount/ViewDesigns/helpers/resizeImageUrlHelper';

const defaultCompProps = {border: 0};

export default class ImageElement extends Component {
  shouldComponentUpdate(nextProps) {
    return !shallowEqual(this.props, nextProps);
  }

  render() {
    const {publish, data, layout, isPreviewMode, desktopId} = this.props;
    let src = data.url;
    if (publish || isPreviewMode) {
      let {height} = layout;
      if (desktopId) {
        height *= 3;
      }
      src = getResizeUrlByUserPreference(src, {height});
    }

    return (
      <BaseElement {...this.props} style={{overflow: 'hidden'}}>
        <img src={src}
             width="100%"
             height="100%"
             alt={data.altText}
             title={data.title}
             style={assign({}, defaultCompProps, data.compProps)}/>
      </BaseElement>
    );
  }
}

ImageElement.propTypes = {
  id: PropTypes.string.isRequired,
  layout: PropTypes.shape({
    x: PropTypes.number.isRequired,
    y: PropTypes.number.isRequired,
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired
  }),
  data: PropTypes.shape({
    url: PropTypes.string.isRequired,
    title: PropTypes.string,
    altText: PropTypes.string,
    href: PropTypes.string,
    compProps: PropTypes.object
  }),
  publish: PropTypes.bool,
};

ImageElement.defaultProps = {
  data: {
    title: '',
    altText: ''
  }
};